export { CostOfInformationChaos } from './CostOfInformationChaos.component';
